export var createMuiSelectOverrides = function (_a) {
    var tokens = _a.tokens;
    return {
        defaultProps: {
            native: true,
            variant: 'outlined',
        },
        styleOverrides: {
            // FIXME: No typings for this. Fix with component migration.
            // selectMenu: {
            //   minHeight: `${round(24 / 14)}em`,
            //   lineHeight: `${round(24 / 14)}em`,
            // },
            select: {
                '&:focus': {
                    backgroundColor: tokens.color_bg_input,
                },
            },
        },
    };
};
